import React, { lazy } from 'react';
interface FooterProps {
  onNavigate?: (path: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const handleNavigation = (path: string) => {
    if (onNavigate) {
      onNavigate(path);
      window.scrollTo(0, 0);
    }
  };
  return <footer className="border-t border-dashed border-[#9ca3af] bg-[#f5f5f7] py-12" data-id="element-43">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4" data-id="element-45">
          <div className="col-span-1 md:col-span-2" data-id="element-46">
            <div className="flex items-center gap-3 mb-4 cursor-pointer" onClick={() => handleNavigation('/')} data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/a1ohPsjKDFpRBQVVygum9S/Logo_and_Teashirt_branding.png" alt="The Networking Salon" loading="lazy" className="h-10 w-auto" data-id="element-48" />
              <div data-id="element-49">
                <span className="font-bold text-sm text-[#1f2933] block leading-tight" data-id="element-50">
                  THE AUTHORITY ENGINE
                </span>
                <span className="font-mono text-[8px] text-[#9ca3af] block" data-id="element-51">
                  By The Networking Salon Ltd.
                </span>
              </div>
            </div>
            <p className="max-w-xs font-mono text-xs text-[#9ca3af] mb-4" data-id="element-52">
              Build authority once. Let it compound.
              <br data-id="element-53" />
              Infrastructure for serious professionals.
            </p>
            <button onClick={() => handleNavigation('/sitemap')} className="font-mono text-xs text-salon-red hover:text-salon-red/80 transition-colors" data-id="element-54">
              View_Site_Map →
            </button>
          </div>

          <div data-id="element-55">
            <h3 className="font-mono text-xs font-bold text-[#1f2933] mb-4" data-id="element-56">
              SYSTEM
            </h3>
            <ul className="space-y-2" data-id="element-57">
              <li data-id="element-58">
                <button onClick={() => handleNavigation('/curriculum')} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors text-left" data-id="element-59">
                  Core_Curriculum
                </button>
              </li>
              <li data-id="element-60">
                <button onClick={() => handleNavigation('/pods')} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors text-left" data-id="element-61">
                  Accountability_Pods
                </button>
              </li>
              <li data-id="element-62">
                <button onClick={() => handleNavigation('/ai')} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors text-left" data-id="element-63">
                  AI_Tools
                </button>
              </li>
              <li data-id="element-64">
                <button onClick={() => handleNavigation('/framework')} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors text-left" data-id="element-65">
                  Content_Framework
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-66">
            <h3 className="font-mono text-xs font-bold text-[#1f2933] mb-4" data-id="element-67">
              LEGAL
            </h3>
            <ul className="space-y-2" data-id="element-68">
              <li data-id="element-69">
                <button onClick={() => handleNavigation('/terms')} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors text-left" data-id="element-70">
                  Terms_of_Service
                </button>
              </li>
              <li data-id="element-71">
                <button onClick={() => handleNavigation('/privacy')} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors text-left" data-id="element-72">
                  Privacy_Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-dashed border-[#9ca3af]/30 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-73">
          <p className="font-mono text-[10px] text-[#9ca3af] text-center sm:text-left" data-id="element-74">
            © {new Date().getFullYear()} THE AUTHORITY ENGINE. ALL RIGHTS
            RESERVED.
          </p>
          <p className="font-mono text-[10px] text-[#9ca3af]" data-id="element-75">
            STATUS: <span className="text-salon-red" data-id="element-76">OPERATIONAL</span>
          </p>
        </div>
      </div>
    </footer>;
}